import { SCOPE as PARENT_SCOPE } from '../types';

export const SCOPE = `${PARENT_SCOPE}.kpiData`;
export const INIT = `${SCOPE}/INIT`;
export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;

export const SET_ACTIVE_TAB = `${SCOPE}/SET_ACTIVE_TAB`;

export const IMP_BENCHMARK = `${SCOPE}/IMP_BENCHMARK`;
export const IMP_OPP_CHARTS = `${SCOPE}/IMP_OPP_CHARTS`;
export const IMP_OPP_AD_CONTENT = `${SCOPE}/IMP_OPP_AD_CONTENT`;
